import React from "react";
import classes from "./courseItem.module.css";

function CourseItem({ title, description, icon, index }) {
  const colors = ["rgba(96, 196, 185, 1)", "rgba(196, 168, 96, 1)", "#6B7CC7", "#C46072", "#FFAA29", "#C74A4A"]
  // Determine color based on the index
  const color = colors[index % colors.length];
  return (
    <div className={classes.courseItem} style={{ "--accent-color": color  }}>
      <div className={classes.content}>
        <h3 className={classes.title}>{title}</h3>
        <p className={classes.description}>{description}</p>
      </div>
      <img src={icon} alt="" className={classes.icon} />
    </div>
  );
}

export default CourseItem;
